import React, { useState } from 'react';
import { ModalDataDeletion } from 'src/components/Modals';
import { SEO } from 'src/components/SEO';

export const DataDeletion: React.FC = () => {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <>
      <SEO
        title="Cancellazione Dati - Kipify"
        robots="noindex, nofollow"
        canonical="https://app.kipify.io/data-deletion"
      />
      <ModalDataDeletion open={open} onClose={() => setOpen(false)} />
    </>
  );
};
